import React from 'react';

import { Link } from '@opendoor/bricks-next';

import { useT } from 'helpers/i18n';

interface LoginSectionProps {
  showLogin: boolean;
  onPress?: () => void;
}

export const LoginSection: React.FC<LoginSectionProps> = ({ showLogin, onPress }) => {
  const { t } = useT();

  if (!showLogin) return null;

  return (
    <Link
      href={'#'}
      onPress={onPress}
      fontWeight="$medium"
      analyticsName="cosmos-sign-in"
      aria-label="Sign in to your account"
      color="$contentPrimary"
    >
      {t('homepage.titles.signIn', 'Sign in')}
    </Link>
  );
};
